import React from 'react';
import irelandApi from '../irelandApi';
import { actions } from 'react-redux-form';
import { toast } from 'react-toastify';
import store, { history } from '../store';
import ToastMessage from '../components/common/toast-message';
import { getOrderNow, updateDeliveryAddress } from './orders';
import { getMyProfile } from './user';
import setAuthorizationToken from '../utils/tokenUtils';
import { toInt } from '../utils/commonFunctions';

export const validateRegistrationOutlet = (payload, registration) => {
  return irelandApi
    .post('/api/users/outlet_validation', { outlet: payload })
    .then(function(response) {
      store.dispatch({
        type: 'OUTLET_VALIDATION_FULFILLED',
        payLoad: {
          customer_number: response.data.outlet.customer_number,
          eircode: response.data.outlet.eircode,
          passcode: response.data.outlet.passcode,
          pay_for_performance: response.data.outlet.pay_for_performance,
          reward_store: response.data.outlet.reward_store
        }
      });
      store.dispatch({
        type: 'SET_REGISTRATION_TOKEN',
        payLoad: {
          registration_token: response.data.registration_token
        }
      });
      store.dispatch(
        actions.change('deep.yourStore', {
          customer_number: response.data.outlet.customer_number,
          updated_eircode: response.data.outlet.eircode,
          updated_name: response.data.outlet.name,
          updated_address_1: response.data.outlet.address_1,
          updated_address_2: response.data.outlet.address_2,
          updated_address_3: response.data.outlet.address_3,
          updated_town: response.data.outlet.town,
          updated_county: response.data.outlet.county,
          reward_store: response.data.outlet.reward_store,
          reward_markup: response.data.outlet.reward_markup
        })
      );
      if (registration.pending && registration.internal) {
        history.push('/your-store');
      } else {
        if (registration.addMore) {
          history.push('/registration/your-store');
        } else {
          history.push('/registration/about-you');
        }
      }
    })
    .catch(function(error) {
      return Promise.reject(error.response.data.errors.outlet);
    });
};

export const updateOutlet = (payload, addMore, registration) => {
  return irelandApi
    .post('/api/users/your_store', {
      outlet: payload,
      registration_token: registration.registration_token
    })
    .then(function(response) {
      const token = response.headers.authorization.split(' ')[1];
      setAuthorizationToken(token);
      store.dispatch(getMyProfile('CURRENT_USER_PROFILE'));
      store.dispatch({
        type: 'SET_REGISTRATION_TOKEN',
        payLoad: {
          registration_token: response.data.registration_token
        }
      });
      if (addMore) {
        store.dispatch({ type: 'ADD_MORE_REGISTRATION' });
        store.dispatch(actions.reset('deep.registration.outlet_validation'));
        store.dispatch(actions.reset('deep.yourStore'));
        if (registration.pending && registration.internal) {
          history.push('/outlet');
        } else {
          history.push('/registration/outlet');
        }
      } else {
        if (registration.pending && registration.internal) {
          store.dispatch({ type: 'FINISH_REGISTRATION' });
          history.push('/store-summary');
        } else {
          history.push('/registration/store-summary');
        }
      }
    })
    .catch(function(error) {
      store.dispatch({
        type: 'SET_REGISTRATION_TOKEN',
        payLoad: {
          registration_token: error.response.data.registration_token
        }
      });
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};

//TODO: simplify with promise middleware like this
//export const getOutlets = () => (dispatch) => dispatch({type: "GET_OUTLETS", payload: irelandApi.get('/api/outlets')});

export const getOutlets = (registration, store_summary = false) => (dispatch, getState) => {
  dispatch({
    type: 'GET_OUTLETS_PENDING',
    payload: []
  });
  return irelandApi
    .get('/api/outlets', {
      params: { param: registration ? 'registration' : '' }
    })
    .then(response => {
      if (response.data.outlet_id !== undefined) {
        // gets when the user is staff, redirect to details page
        if (store_summary) {
          history.push('/store-details/' + response.data.outlet_id);
        }
        dispatch({
          type: 'GET_MISSING_PRODUCTS_FULFILLED',
          payLoad: response.data.missing_stock_it_product_ids_from_audit
        });
        dispatch({
          type: 'GET_ACTIVE_GAME_FULFILLED',
          payLoad: response.data.active_game
        });
        if (
          response.data.meta &&
          response.data.meta['available_voucher_types']
        ) {
          dispatch({
            type: 'GET_OUTLET_VOUCHERS_FULFILLED',
            payLoad: response.data.meta['available_voucher_types']
          });
        }

        return;
      }

      if (registration) {
        const outlets = response.data.data.map(store => {
          const reward = store.attributes['reward-details'];
          if (reward) {
            return {
              id: store.id,
              customer_number: store.attributes['customer-number'],
              reward_markup: reward['reward-markup'],
              auto_redeem: reward['auto-redeem'],
              voucher_type_id: reward['voucher-type']
                ? reward['voucher-type'].id
                : '',
              voucher_denomination_id: reward['voucher-denomination']
                ? reward['voucher-denomination'].id
                : ''
            };
          } else {
            return {
              customer_number: store.attributes['customer-number']
            };
          }
        });
        dispatch({
          type: 'GET_OUTLET_VOUCHERS_FULFILLED',
          payLoad: response.data.meta['available-voucher-types']
        });
        dispatch(actions.load('deep.store_summary', outlets));
      }
      dispatch({
        type: 'GET_OUTLETS_FULFILLED',
        payLoad: response.data
      });
      dispatch(updateDeliveryAddress(getState().viewConfig.profile.attributes['default-outlet-id']));
      return Promise.resolve(response.data);
    })
    .catch(error => {
      dispatch({
        type: 'GET_OUTLETS_REJECTED',
        payLoad: error
      });
      return Promise.reject(error);
    });
};

export const getAdminOutlets = (filter = '', page = '') => dispatch => {
  dispatch({
    type: 'GET_OUTLETS_PENDING',
    payload: []
  });
  return irelandApi
    .get('/api/admin/outlets', { params: { q: filter, page: page } })
    .then(response => {
      dispatch({
        type: 'GET_ADMIN_OUTLETS_FULFILLED',
        payLoad: response.data
      });
    })
    .catch(error => {
      dispatch({
        type: 'GET_OUTLETS_REJECTED',
        payLoad: error.data
      });
      return Promise.reject(error.response.data);
    });
};

export const getCustomerNumbers = (filter = '', page = '') => dispatch => {
  filter = '?q=' + filter + '&page = ' + page;
  dispatch({
    type: 'GET_OUTLETS_CN_PENDING',
    payload: []
  });
  return irelandApi
    .get('/api/admin/outlets/customer_numbers' + filter)
    .then(response => {
      dispatch({
        type: 'GET_OUTLETS_CN_FULFILLED',
        payLoad: response.data
      });
    })

    .catch(error => {
      dispatch({
        type: 'GET_OUTLETS_CN_REJECTED',
        payLoad: error.data
      });
      return Promise.reject(error.response.data);
    });
};

export const getOutlet = id => dispatch => {
  dispatch({
    type: 'GET_OUTLET_PENDING',
    payload: []
  });
  return irelandApi
    .get('/api/outlets/' + id)
    .then(response => {
      dispatch({
        type: 'GET_OUTLET_FULFILLED',
        payLoad: response.data
      });
      const rewards = response.data.data.attributes['my-rewards'];
      if (rewards) {
        dispatch(getOrderNow(id));
      }
    })
    .catch(error => {
      dispatch({
        type: 'GET_OUTLET_REJECTED',
        payLoad: error.response
      });
    });
};

export const getAdminOutlet = id => dispatch => {
  dispatch({
    type: 'GET_OUTLET_PENDING',
    payload: []
  });
  return irelandApi
    .get('/api/admin/outlets/' + id)
    .then(response => {
      dispatch({
        type: 'GET_OUTLET_FULFILLED',
        payLoad: response.data
      });

      const { attributes } = response.data.data;
      if (attributes['reward-store']) {
        store.dispatch(
          actions.change(
            'deep.admin_outlet_view.auto_redeem',
            attributes['rewards-details']['auto-redeem']
          )
        );
      }
    })
    .catch(error => {
      // dispatch({type: 'GET_OUTLET_REJECTED', payLoad: error});

      return Promise.reject(error);
    });
};

export const delinkOutlet = payLoad => dispatch => {
  dispatch({
    type: 'GET_OUTLETDELINK_PENDING',
    payload: []
  });
  const payLoadRequest = {
    delink_date: payLoad.delink_date,
    delink_reason: payLoad.delink_reason,
    supress_notification: payLoad.supress_notification
  };
  return irelandApi
    .patch('/api/admin/outlets/' + payLoad.outlet + '/delink', {
      delink: payLoadRequest
    })
    .then(response => {
      dispatch({ type: 'GET_OUTLETDELINK_FULFILLED' });
      dispatch(actions.reset('deep.admin_delink'));
      history.push('/admin/outlets/delink');
      toast.success(
        <ToastMessage
          iconStyle="success"
          message="Outlet has been successfully delinked"
        />
      );
    })
    .catch(error => {
      toast.error(
        <ToastMessage
          iconStyle="error"
          message="An error occured during delink"
        />
      );
      dispatch({
        type: 'GET_OUTLETDELINK_REJECTED',
        payLoad: error.data
      });
      return Promise.reject(error.data);
    });
};

export const delinkUserOutlet = storeId => dispatch => {
  dispatch({
    type: 'GET_USEROUTLETDELINK_PENDING',
    payload: []
  });
  return irelandApi
    .get('/api/outlets/' + storeId + '/outlet_removal')
    .then(response => {
      dispatch({ type: 'GET_USEROUTLETDELINK_FULFILLED' });
      toast.success(
        <ToastMessage
          iconStyle="success"
          message="Outlet delink request has been successfully sent"
        />
      );
    })
    .catch(error => {
      dispatch({
        type: 'GET_USEROUTLETDELINK_REJECTED',
        payLoad: error.data
      });
    });
};

export const updateOutletReward = payload => {
  return irelandApi
    .patch('/api/users/staff_rewards', { outlets: payload })
    .then(function(response) {
      store.dispatch({ type: 'FINISH_REGISTRATION' });
      window.location.href = '/';
    })
    .catch(function(error) {
      toast.error(
        <ToastMessage
          iconStyle="error"
          message="An error occured during update staff reward"
        />
      );
      return Promise.reject(error.response.data);
    });
};

export const updateOutletRest = (id, payload, dispatch) => {
  const data = {
    ...payload,
    reward_markup: payload.reward_markup,
    auto_redeem: payload.reward_markup === 0 ? false : payload.auto_redeem
  };
  dispatch(actions.resetValidity('deep.admin_outlet_view'));
  dispatch({ type: 'GET_OUTLET_UPDATE_PENDING' });

  return irelandApi
    .patch('/api/admin/outlets/' + id, { outlet: data })
    .then(response => {
      dispatch({
        type: 'GET_OUTLET_UPDATE_FULFILLED',
        payload: response.data
      });
      toast.success(
        <ToastMessage
          iconStyle="success"
          message="Outlet has been successfully saved"
        />
      );
      history.push('/admin/outlets');
    })
    .catch(error => {
      toast.error(
        <ToastMessage
          iconStyle="error"
          message="An error occured during save outlet"
        />
      );
      dispatch({
        type: 'GET_OUTLET_UPDATE_FULFILLED',
        payload: error.response.data
      });

      if (error.response.data.hasOwnProperty('errors')) {
        return Promise.reject(error.response.data.errors);
      }

      return Promise.reject(error.response.data);
    });
};

export const confirmDefaultStoreChoice = storeId => (dispatch) => {
  const id = parseInt(String(storeId), 10);
  const payload = { storeId: id };
  dispatch({ type: 'SET_DEFAULT_STORE_CONFIRMING', payload });
};

export const setDefaultStore = storeId => (dispatch) => {
  const id = toInt(storeId);
  const payload = { storeId: id };
  dispatch({ type: 'SET_DEFAULT_STORE_PENDING', payload });
  return irelandApi
    .post('/api/outlets/default', { id })
    .then(response => {
      dispatch({ type: 'SET_DEFAULT_STORE_FULFILLED', payload });
      dispatch(updateDeliveryAddress(id))
      toast.success(
        <ToastMessage iconStyle="success" message="Default store set" />
      )
    })
    .catch(error => {
      dispatch({ type: 'SET_DEFAULT_STORE_REJECTED', payload: error.response.data });
      toast.error(
        <ToastMessage iconStyle="error" message="Unable to set default store" />
      )
    })
}



// WEBPACK FOOTER //
// ./src/actions/outlet.js